import * as swcHelpers from '@swc/helpers';
import { isBoolean, isDefined } from '@grandvisionhq/utils';
import { getBrandModelAttributes } from '../utils/get-brand-model-attributes.js';
import { getFaceShapes } from '../utils/get-face-shapes.js';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToFrameSpecifications } from '../specification-mappers/map-server-to-frame-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';
import { getSharedFrameVariantProps } from './shared/get-shared-frame-variant-props.js';

const mapServerToFrameVariant = (serverProduct, slug, locale, priceSegmentChannelKey)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale, priceSegmentChannelKey);
        if (!variantBase) return;
        const { variantTypeDetails  } = serverVariant;
        const { brand  } = serverProduct;
        const specifications = mapServerToFrameSpecifications(serverVariant, brand, locale, !!serverProduct.productTypeDetails.isOfferedWithPrescriptions);
        const brandModelAttributes = getBrandModelAttributes(serverVariant);
        const isInsuranceReimbursable = isBoolean(variantTypeDetails.isInsuranceReimbursable) ? variantTypeDetails.isInsuranceReimbursable : undefined;
        const frame = swcHelpers.objectSpread({}, variantBase, getSharedFrameVariantProps(variantTypeDetails), brandModelAttributes, {
            variantType: 'frames',
            faceShapes: getFaceShapes(variantTypeDetails.faceShape),
            specifications,
            isVtoEnabled: variantTypeDetails.isVtoEnabled,
            isInsuranceReimbursable,
            isReservable: variantTypeDetails.isReservable
        });
        return frame;
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToFrameVariant };
//# sourceMappingURL=map-server-to-frame-variant.js.map
